import { Component, OnInit } from '@angular/core';
import { InvoiceService } from 'src/app/services/invoice/invoice.service';
import { Route, Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Invoicetrackreq } from 'src/app/model/invoicetrackreq.model';
//import { formArrayNameProvider } from '@angular/forms/src/directives/reactive_directives/form_group_name';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-invoiceuploded',
  templateUrl: './invoiceuploded.component.html',
  styleUrls: ['./invoiceuploded.component.css']
})
export class InvoiceuplodedComponent implements OnInit {
  vendorInvoice: Invoicetrackreq;
  InvoiceDocs: any;
  vendorInvoiceData: any;
  form: FormGroup;
  stepno: any;
  data: any;
  readonly rootUrl = environment.baseUrl;

  constructor(private invoiceservice: InvoiceService, private router: Router,
    private route: ActivatedRoute, private fb: FormBuilder) {

  }

  ngOnInit() {
    this.getInvoiceDocs();
    //this.getvendorInvoiceById();
  }

  getInvoiceDocs() {

    this.invoiceservice.GetInvoiceDocs().subscribe(
      (data: any) => {
        //alert("working");
        console.log("sdfkj");
        this.InvoiceDocs = data;
        console.log(this.InvoiceDocs);
      }
    );
  }

  getSelectedInvoiceLines(invoiceid)
  {
    //alert(invoiceid);
    // this.invoiceservice.getSelectedInvoiceLines(invoiceid).subscribe(
    //   (data : any) => {
    //     this.data = data;
    //     console.log(this.data);
    //   }
    // )
    //invoiceid = 1;
    this.router.navigate(['/viewinvoicedetail/' + invoiceid + '']);
  }

  invoicevendorsearch(keyword) {

    this.invoiceservice.InvoiceVendorSearch(keyword).subscribe(
      (data) => {
        //this.data = data;
        console.log(data);
      }
    )

  }

}
